import type {
  CommonTouchBase,
  DeviceOrientationBase,
  DoubleTouchBase,
  MouseTouchBase,
  SingleTouchBase,
} from './InputBase';

//------------------------------------
export type CameraType = 'Default' | 'AR';
export const CameraPresetTypes = ['Default', 'AR'];

export type CameraInputParam = {
  desktop?: (MouseTouchBase | CommonTouchBase)[];
  mobile?: (SingleTouchBase | CommonTouchBase | DoubleTouchBase | DeviceOrientationBase)[];
};
